import Region from '@/creditflowresearch/domain/Region/Region';
import { RegionType } from '@/creditflowresearch/domain/Region/RegionType';
import { LATM_REGION_ID, LATM_ABBREVIATION } from '@/creditflowresearch/domain/Region/constants';
import { EMERGING_MARKET_ID } from '@/creditflowresearch/domain/Market/constants';

class LatmRegion extends Region {
  static readonly REGION_ID: string = LATM_REGION_ID;

  static readonly ABBREVIATION: string = LATM_ABBREVIATION;

  static readonly TYPE: RegionType = RegionType.LATM;

  protected getMarketIdForRegion(): string | null {
    return EMERGING_MARKET_ID;
  }
}

export default LatmRegion;
